import { uniqBy } from 'lodash';

import { PaymentDetails } from './screens/PaymentsScheduled/PaymentsScheduled.types';

export function getVendorsIdsWithoutEmail(paymentsDetails: PaymentDetails[]) {
  return uniqBy(paymentsDetails, (payment) => payment.vendor.id)
    .filter((payment) => !payment.vendor.contact.email)
    .map((payment) => payment.vendor.id);
}
